import React from 'react';
import AssetConditonList from '../../components/assetConditionComponents/AssetConditionList';
import { useDispatch } from 'react-redux';
import { setHeaderName } from '../../redux/actions/userActions';

const AssetConditionListPage = () => {
    const dispatch = useDispatch();
    dispatch(setHeaderName('SET_HEADER_NAME', 'Assets'));
    return <AssetConditonList />
}

export default AssetConditionListPage